import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logotrans.png";
import { publicRoutes, authRoutes, isProtectedRoute, isAuthRoute } from "../config/navigation";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const linkClasses = (path) =>
    `relative px-3 py-2 transition-all duration-300 text-white whitespace-nowrap group ${
      location.pathname === path
        ? "bg-[#19BFB7] text-white rounded-xl"
        : "hover:bg-opacity-80"
    } focus:outline-none`;

  const renderAuthButtons = () => {
    if (token) {
      return (
        <button
          onClick={handleLogout}
          className="bg-red-500 text-white py-2 px-4 rounded-xl transition duration-500 transform hover:scale-105"
        >
          Log Out
        </button>
      );
    }

    return (
      <>
        {authRoutes
          .filter(route => route.path.includes("/login/"))
          .map(route => (
            <Link key={route.path} to={route.path}>
              <button className={`${
                route.type === "recruiter" ? "bg-[#6960EC]" : "bg-[#38ACEC]"
              } text-white py-2 px-4 rounded-xl transition duration-500 transform hover:scale-105`}>
                {route.label}
              </button>
            </Link>
          ))}
      </>
    );
  };

  return (
    <nav className="w-full bg-transparent p-4 z-50">
      <div className="flex items-center max-w-8xl mx-auto px-4 flex-nowrap">
        <Link to="/" className="flex-shrink-0">
          <img src={logo} alt="AIAURA Logo" className="h-12 w-auto lg:h-16" />
        </Link>

        <div className="hidden lg:flex flex-1 justify-center mx-4">
          <div
            className="flex space-x-4 px-1 py-1 rounded-xl bg-[#112D4E]"
            style={{ boxShadow: "5px 10px 20px rgba(25, 191, 183, 0.4)" }}
          >
            {publicRoutes.map(route => (
              <Link
                key={route.path}
                to={route.path}
                className={linkClasses(route.path)}
              >
                {route.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="hidden lg:flex space-x-4 flex-shrink-0">
          {renderAuthButtons()}
        </div>

        <button
          className="lg:hidden text-white focus:outline-none ml-auto"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>
      </div>

      <div
        className={`lg:hidden w-full bg-[#0c2139] transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-screen py-4 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="flex flex-col items-center space-y-4 px-4 py-2">
          {publicRoutes.map(route => (
            <Link
              key={route.path}
              to={route.path}
              className={linkClasses(route.path)}
              onClick={toggleMenu}
            >
              {route.label}
            </Link>
          ))}
          {renderAuthButtons()}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
